import DecedentDocs from '@/common/containers/Forms/DecedentDocs/DecedentDocs';

export default DecedentDocs;
